<template>
  <div class="content">
    <Header :title="'消费币兑换'" />
    <div class="tab-wrap">
      <div class="tab-head">
        <div class="col-2" :class="[tabIndexShow === 0 ? 'active' : '']" @click="tabIndexShow = 0">兑 换</div>
        <div class="col-2" :class="[tabIndexShow === 1 ? 'active' : '']" @click="tabIndexShow = 1">兑换记录</div>
      </div>
      <div class="tab-body">
        <!-- 兑 换 -->
        <div v-show="tabIndexShow === 0" class="tab">
          <div class="lists">
            <ul>
              <li class="title">
                <span>金额</span>
                <span>消费币</span>
                <span />
              </li>
              <li v-for="(item, index) in list1" :key="index">
                <span>{{ item.count }}元</span>
                <span>{{ item.coin }}</span>
                <span class="btn-query">
                  <input type="button" value="兑换" @click="toExchange(item.orderGuId)">
                </span>
              </li>
              <div v-show="list1.length === 0" class="no-data">抱歉！暂无数据</div>
            </ul>
          </div>
        </div>
        <!-- 兑换记录 -->
        <div v-show="tabIndexShow === 1" class="tab">
          <div class="search-wrap">
            <div class="txt-wrap">
              <input v-model="kw" type="text" placeholder="日期如:2020-01-01/金额如:1" class="txt-search">
              <div class="btn-wrap">
                <input type="button" value="搜索" class="btn-search" @click="onSearch">
              </div>
            </div>
          </div>

          <div class="lists">
            <ul>
              <li class="title">
                <span>用户昵称</span>
                <span>兑换金额</span>
                <span>兑换时间</span>
              </li>
              <li v-for="(item, index) in list2" :key="index">
                <span>{{ item.memberNickName }}</span>
                <span>{{ item.count }}元</span>
                <span>{{ item.createdDate }}</span>
              </li>
              <div v-show="list2.length === 0" class="no-data">抱歉！暂无数据</div>
            </ul>
          </div>

          <!-- 分页 -->
          <div class="page-container">
            <van-pagination
              v-model="pageIndex"
              :total-items="total"
              :show-page-size="1"
              :items-per-page="pageSize"
              force-ellipses
              @change="pageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <!--弹窗-确认兑换 -->
    <my-dialog
      v-if="dialogShow"
      cancel="取消"
      confirm="确定"
      title="确认兑换？"
      @close="closeDialog"
      @submit="submitDialog"
    />
    <!-- 底部 -->
    <Footer :active="4" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Pagination } from 'vant'
import { Toast } from '@nutui/nutui'
import { notRedeemed, convertMoney, convertMoneyRecord } from '@/api/Personal/Setting/index'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'
import MyDialog from '@/components/MyDialog/Index'

Vue.use(Pagination)

export default {
  name: 'MoneyExchange',
  components: {
    Header,
    Footer,
    MyDialog
  },
  data() {
    return {
      kw: '',
      pageIndex: 1,
      pageSize: 8,
      total: 1,
      tabIndexShow: 0,
      list1: [],
      list2: [],
      dialogShow: false,
      covertId: ''
    }
  },
  mounted() {
    this.getNotRecord()
    this.getIsRecord()
  },
  methods: {
    // 获取--未兑换-充值记录
    getNotRecord() {
      notRedeemed().then(res => {
        if (res && res.success) {
          if (res.data) {
            this.list1 = res.data
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 兑换
    toExchange(id) {
      this.covertId = id
      this.dialogShow = true
    },
    // 获取--兑换记录
    getIsRecord() {
      const _this = this
      const params = {
        kw: this.kw,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      convertMoneyRecord(params).then(res => {
        if (res && res.success) {
          this.total = res.data.total
          if (res.data.rows) {
            this.list2 = res.data.rows
            this.list2.forEach(item => {
              item.createdDate = _this.$formatDate(item.createdDate.slice(0, 10), '-')
            })
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // --确认--兑换
    submitDialog() {
      this.dialogShow = false
      convertMoney(this.covertId).then(res => {
        if (res && res.success) {
          Toast.success('兑换成功')
          this.getNotRecord()
          this.getIsRecord()
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // --取消--兑换
    closeDialog() {
      this.dialogShow = false
    },
    getClass(item, index) {
      this.cardIndex = index
      this.cardMoney = item
    },
    // 搜索
    onSearch() {
      this.getIsRecord()
    },
    // 换页
    pageChange() {
      this.getIsRecord()
    }
  }
}
</script>
<style lang="scss" scoped>
// 分页
.van-pagination {
  margin-bottom: 30px;
  justify-content: center;

  ::v-deep .van-pagination__item {
    color: #555;
    border-radius: 5px;
    margin: 0 3px;
    font-weight: bold;
    height: 35px;
  }

  ::v-deep .van-pagination__item::after {
    display: none;
  }

  ::v-deep .van-pagination__item:disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item:active {
    background-color: $primary-color-bright;
    color: #fff;
  }

  ::v-deep .van-pagination__item--disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item--active {
    background-color: #fff;
    color: $primary-color;
  }

  ::v-deep .van-pagination__prev {
    max-width: 150px;
  }

  ::v-deep .van-pagination__next {
    max-width: 150px;
  }
}

.content {
  width: 100vw;
  min-height: 0;
  height: auto;
  overflow: hidden;
  padding: 18px 0 80px 0;

  .tab-head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;

    .col-2 {
      width: 50%;
      height: 40px;
      float: left;
      position: relative;
      text-align: center;
      box-sizing: border-box;
      color: #4d4d4d;
      border-bottom: 2px solid #cccccc;
      font-size: 16px;
      font-weight: 600;

      &.active {
        color: #eea105;
        border-bottom: 2px solid #eea105;
      }
    }
  }

  .tab-body {
    width: 100%;
    min-height: 0;
    height: auto;
    overflow: hidden;
    padding: 18px;
    box-sizing: border-box;

    .tab {
      width: 100%;
      min-height: 0;
      height: auto;
      overflow: hidden;
      position: relative;

      .search-wrap {
        width: 100%;
        height: 60px;

        .txt-wrap {
          width: 100%;
          position: relative;
          box-sizing: border-box;
          padding-right: 90px;

          input {
            width: 100%;
            height: 40px;
            background: #ffffff;
            border: none;
            color: #4c4c4c;
            outline: none;
            border-radius: 5px;
            -webkit-appearance: none;
            appearance: none;
            font-size: 14px;
            box-sizing: border-box;
            padding: 0 10px;
          }

          .btn-wrap {
            width: 80px;
            height: 40px;
            position: absolute;
            right: 0;
            top: 0;

            input {
              width: 100%;
              height: 40px;
              background: #eea105;
              border: none;
              color: #ffffff;
              outline: none;
              border-radius: 5px;
              -webkit-appearance: none;
              appearance: none;
              font-size: 14px;
              text-align: center;
            }
          }
        }
      }

      .lists {
        width: 100%;
        min-height: 50px;
        height: auto;
        overflow: hidden;
        background: #ffffff;
        border-radius: 5px;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 0 0 10px 0;

        ul {
          display: block;
          width: 100%;
          height: 100%;

          li {
            height: 40px;
            span {
              display: block;
              width: 33.333333%;
              float: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 12px;
              color: #bcbcbc;
              text-align: center;
              line-height: 40px;
              height: 40px;
              padding: 0 5px;
              box-sizing: border-box;
            }

            .btn-query {
              padding: 3px 20px;
              box-sizing: border-box;
              input {
                width: 100%;
                height: 100%;
                line-height: 100%;
                background: #eea105;
                border-radius: 3px;
                -webkit-border-radius: 3px;
                -webkit-appearance: none;
                color: #ffffff;
                border: none;
                font-size: 14px;
              }
            }
          }

          .title {
            width: 100%;
            height: 50px;
            border-bottom: 1px solid #f7f7f7;

            span {
              font-weight: 600;
              color: #4d4d4d;
              line-height: 50px;
            }
          }

          .no-data {
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            color: #999999;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
